import { render, staticRenderFns } from "./accounttransaction.vue?vue&type=template&id=383f83ac&"
import script from "./accounttransaction.vue?vue&type=script&lang=js&"
export * from "./accounttransaction.vue?vue&type=script&lang=js&"
import style0 from "./accounttransaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports